export default __webpack_public_path__ + "static/media/featured_04.3127ba5e.jpg";